














































































































































import Component, { mixins } from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import MyMixin from "@/mixins/datemixin";
import { MyOptions } from "@/charts/graphData";
import moment from "moment/moment";
import jsonURL from "@/shared/urls";
import { Event, Collab, PerimAffects } from "@/shared/Event";
import ErrorMixin from "@/mixins/errorMixins";
import PrevCalendar from "@/ui-component/PrevCalendar.vue";
import AddEvent from "@/components/addEvent.vue";
import EventMixin from "@/mixins/eventMixin";
import ResumeEvent from "@/ui-component/resumeEvent.vue";

@Component({
  components: {
    PrevCalendar,
    AddEvent,
    ResumeEvent,
  },
})
export default class HomeCalendar extends mixins(
  MyMixin,
  ErrorMixin,
  EventMixin
) {
  @Prop() public myOptions!: MyOptions;
  @Prop({ default: false }) public showCalendar!: boolean;
  @Prop({ default: false }) public preLoadCalendar!: boolean;
  public type = "month";
  public value = new Date();
  public events = new Array();
  public addEventDial = false;
  public addEvent: Event = new Event();
  public caMonth = new Array();
  public showFiab = false;
  public serverEvents: Event[] = new Array();
  public prevs: any;
  public eventActivated = false;
  public prevHierarchie: Collab = new Collab(new Event(), new Array());
  public showResume = false;
  public selectedDayEvts = { date: moment(), events: new Array(), prev: {} };
  public today = moment().format("YYYY-MM-DD");

  private get calendarInstance(): Vue & {
    prev: () => void;
    next: () => void;
    checkChange: () => void;
    getVisibleEvents: () => any[];
    getFormatter: (format: any) => any;
  } {
    return this.$refs.calendar as Vue & {
      prev: () => void;
      next: () => void;
      checkChange: () => void;
      getVisibleEvents: () => any[];
      getFormatter: (format: any) => any;
    };
  }

  public mounted() {
    //
  }

  @Watch("preLoadCalendar", { immediate: true })
  public init({ value, oldValue }: { value: any; oldValue: any }) {
    this.value = this.myOptions.date;
    this.getFiabs();
    this.getEvents();
  }

  public closeCalendar() {
    this.$emit("closeCalendar");
    this.init({ value: null, oldValue: null });
  }

  public setToday() {
    // console.log(this.type);
    this.type = "month";
    this.value = new Date();
  }
  /**
   * Methode de récupération des Ca TTC par jour sur le mois affiché
   */
  public async getEvents() {
    this.events = new Array();
    if (this.client !== "BK") {
      return;
    }
    // console.log("value", this.value);
    let config = {
      site: this.myOptions.site[0],
      date: moment(this.value).subtract(1, "months").format("YYYY-MM-DD"),
      WS: jsonURL.updateCAHTParJourSurMois,
    };
    // console.log("here I am", config.site);
    this.$store.dispatch("home/getGraphData", { config, p: -1 }).then(
      (data: any) => {
        this.caMonth = new Array();
        this.caMonth = data;
        this.events = this.decryptCA(data, this.events);
      },
      (error: any) => {
        console.error(error);
        const err = this.$t("recupEventError").toString();
        this.setErrorFromTxt(err);
      }
    );
    config = {
      site: this.myOptions.site[0],
      date: moment(this.value).add(1, "months").format("YYYY-MM-DD"),
      WS: jsonURL.updateCAHTParJourSurMois,
    };
    // console.log("here I am", config.site);
    this.$store.dispatch("home/getGraphData", { config, p: -1 }).then(
      (data: any) => {
        this.caMonth = new Array();
        this.caMonth = data;
        this.events = this.decryptCA(data, this.events);
      },
      (error: any) => {
        console.error(error);
        const err = this.$t("recupEventError").toString();
        this.setErrorFromTxt(err);
      }
    );
    config = {
      site: this.myOptions.site[0],
      date: moment(this.value).format("YYYY-MM-DD"),
      WS: jsonURL.updateCAHTParJourSurMois,
    };
    // console.log("here I am", config.site);
    this.$store.dispatch("home/getGraphData", { config, p: -1 }).then(
      (data: any) => {
        this.caMonth = data;
        this.events = this.decryptCA(data, this.events);
        if (this.client === "BK") {
          this.$store.dispatch("home/getEvents", config).then(
            (evts: Collab) => {
              /*if (evts.param_hierarchies && evts.param_hierarchies.length > 0) {
                this.eventActivated = true;
              }*/
              this.prevHierarchie = evts;
              this.serverEvents = evts.main_evenements
                ? evts.main_evenements.filter(
                    (ev: Event) => !ev.flag_suppression
                  )
                : new Array();
              this.events = this.transformCalendarEvents(
                this.serverEvents,
                this.events
              );
            },
            (error: any) => {
              const err = this.$t("recupEventError").toString();
              this.setErrorFromTxt(err);
            }
          );
        }
      },
      (error: any) => {
        console.error(error);
        const err = this.$t("recupEventError").toString();
        this.setErrorFromTxt(err);
      }
    );
  }

  public getFilteredEvents() {
    return this.events; // .sort((a: any, b: any) => a.index > b.index ? 1 : -1)
  }

  public getADay(ev: any) {
    // console.log(ev);
    this.selectedDayEvts = { date: ev.date, events: new Array(), prev: {} };
    this.selectedDayEvts.events = this.getDayEvent(ev.date);
    this.selectedDayEvts.prev = this.prevs[ev.date];
    this.showResume = true;
  }

  public closeAddEvent() {
    this.addEventDial = false;
    this.addEvent = new Event();
  }

  public AddMeAnEvent() {
    this.addEvent = new Event();
    this.addEventDial = true;
  }
  /**
   * methode de création / modification d'un evenemnt
   */
  public saveEvent(collab: Collab) {
    const event = collab.main_evenements
      ? collab.main_evenements[0]
      : new Event();
    // console.log(event.couleur);
    const isAdd = event.version === 1 ? true : false;
    this.addEvent.tauxImpact = Number(this.addEvent.tauxImpact);
    // console.log("ajout ?", isAdd, event.version);
    if (isAdd) {
      this.$store.dispatch("home/addEvents", collab).then(
        (response: any) => {
          this.addEventDial = false;
          this.serverEvents.push(this.addEvent);
          this.decryptNewEvent(this.addEvent);
          this.setSuccess(this.$t("eventAdded").toString());
        },
        (error: any) => {
          const err = this.$t("savedError").toString();
          this.setErrorFromTxt(error.message, err);
        }
      );
    } else {
      this.$store.dispatch("home/updateEvents", collab).then(
        (response: any) => {
          console.log(response);
          this.addEventDial = false;
          this.serverEvents.map((evt: Event) => {
            if (evt.uuid_evt === this.addEvent.uuid_evt) {
              evt = event;
              // console.log(evt.date_debut);
            }
          });
          // console.log(this.serverEvents);
          this.setSuccess(this.$t("eventEdited").toString());
          this.decryptNewEvent(event);
        },
        (error: any) => {
          const err = this.$t("savedError").toString();
          this.setErrorFromTxt(error.message, err);
        }
      );
    }
    this.calendarInstance.checkChange();
  }
  /**
   * methode d'affichage de l'event selectionné pour modification ou suppression
   * @param param0
   */
  public showEvent({ nativeEvent, event }: any) {
    if (event.type === "ca" || event.type === "prev") {
      // TODO : ajouter type national (ou alors juste visualisation)
      return;
    }
    const evt = this.serverEvents.find((ev: Event) => ev.uuid_evt === event.id);
    if (evt !== undefined) {
      this.addEvent = evt;
    }
    this.addEventDial = true;
    nativeEvent.stopPropagation();
  }
  /**
   * methode de suppression d'un evenement
   */
  public deleteEvt(event: Event) {
    event.flag_suppression = true;
    this.prevHierarchie.perim_affects.map((perim: PerimAffects) => {
      if (perim.uuid_evt === event.uuid_evt) {
        perim.flag_suppression = true;
      }
    });
    // console.log(event);
    this.$store.dispatch("home/deleteEvents", event).then(
      (_) => {
        this.addEventDial = false;
        this.setSuccess(
          this.addEvent.designation + " " + this.$t("deleted").toString()
        );
        this.events = this.events.filter(
          (ev: any) => ev.id !== this.addEvent.uuid_evt
        );
        this.calendarInstance.checkChange();
      },
      (error: any) => {
        const err = this.$t("savedError").toString();
        this.setErrorFromTxt(error.message, err);
      }
    );
  }
  /**
   * Méthode permettant de fermet le calendrier
   * en changeant la date de la page d'accueil par celle selectionnée
   */
  public analyseFiabilite() {
    if (this.client !== "BK" || !this.eventActivated) {
      return;
    }
    // TODO event : enlever retrun false + d-none sur le bouton ajout evt
    // return false;
    this.showFiab = true;
  }
  /**
   * methode de mise a jour de la date depuis le résumé journée
   * @param ev - la date au format YYYY-MM-DD
   */
  public updateDate(ev: any) {
    this.myOptions.date = moment(ev).toDate();
    this.selectedDayEvts = { date: ev, events: new Array(), prev: {} };
    this.selectedDayEvts.events = this.getDayEvent(ev);
    this.selectedDayEvts.prev = this.prevs[ev];
  }
  /**
   * reload des chiffres si le calendrier à été ouvert une premiere fois
   */
  @Watch("myOptions", { immediate: true, deep: true })
  public onDateChanged({ value, oldValue }: { value: any; oldValue: any }) {
    if (oldValue !== value) {
      this.value = this.myOptions.date;
      // console.log("watch date");
      this.getEvents();
      this.getFiabs();
      this.showFiab = false;
    }
  }

  // @Watch("value", { immediate: true, deep: true })
  // public onPeriodeChange({ value, oldValue }: { value: any; oldValue: any }) {
  //   if (this.showFiab) {
  //     return;
  //   }
  //   if (this.value !== this.myOptions.date) {
  //     this.getEvents();
  //     this.getFiabs();
  //     this.showFiab = false;
  //   }
  // }

  public closeFiab() {
    this.showFiab = false;
  }

  public viewDay(date: any) {
    this.value = new Date(date.date);
    this.type = "day";
  }

  public closeResume() {
    this.showResume = false;
  }
  /**
   * méthode de récupération de la fiabilité des estimations CA
   */
  private getFiabs() {
    this.$store.dispatch("home/getPrev").then((response: any) => {
      this.prevs = response;
      if (!this.prevs) {
        return;
      }
      const myevents = this.transformFiabs(this.prevs);
      if (myevents && myevents.length > 0) {
        this.events = this.events.concat(myevents);
      }
      this.eventActivated = true;
    });
  }
  /**
   * methode permettant de chercher si un evenement recu est déja présent sur le calendrier
   * @param ev l'evenement qu'on cherche
   */
  private decryptNewEvent(ev: Event) {
    // console.log("decryptNewEvent", ev.couleur, ev.date_debut);
    const event = {
      name: ev.designation,
      start: this.getDate(ev.date_debut),
      end: this.getDate(ev.date_fin),
      color: "#fdd835",
      timed: false,
      type: "LOC",
      id: ev.uuid_evt,
    };
    const exist = this.events.findIndex((evt: any) => evt.id === event.id);
    // console.log("exist", exist);
    if (exist !== undefined) {
      this.events.splice(exist, 1);
      this.events.push(event);
    } else {
      this.events.push(event);
    }
    this.calendarInstance.checkChange();
  }

  private getDayEvent(date: string) {
    const monjour = moment(date);
    return this.events.filter((ev: any) => {
      return (
        ev.type !== "ca" &&
        ev.type !== "prev" &&
        monjour.isSameOrAfter(ev.start, "day") &&
        monjour.isSameOrBefore(ev.end, "day")
      );
    });
  }

  get client(): string {
    return this.$store.getters["getClient"];
  }
}
